import Attachment from './Attachment';
import NameCard from './nameCard/NameCard';
import Button from './Button';
import Label from './Label';
import Icon from './Icon';
import BreadCrumb from './breadcrumb/BreadCrumb';
import BreadCrumbItem from './breadcrumb/BreadCrumbItem';
import Spinner from './Spinner';
import Tip from './Tip';
import Chip from './Chip';
import LoadMore from './LoadMore';
import Pagination from './pagination/Pagination';
import ReportPagination from './reportPagination/ReportPagination';
import ModalTrigger from './ModalTrigger';
import ActionButtons from './ActionButtons';
import EmptyState from './EmptyState';
import Bulk from './Bulk';
import Filter from './filter/Filter';
import Tags from './Tags';
import FilterableList from './filterableList/FilterableList';
import DropdownToggle from './DropdownToggle';
import ImportFile from './ImportFile';
import ChooserSelector from './ChooserSelector';
import {
  FormControl,
  ControlLabel,
  FormGroup,
  Textarea,
  SelectWithSearch
} from './form';
import { Step, Steps, ConditionStep } from './step';
import TextDivider from './TextDivider';
import CountsByTag from './CountsByTag';
import FilterByParams from './FilterByParams';
import Table from './table';
import { Tabs, TabList, TabTitle } from './tabs';
import ConfirmDialog from './ConfirmDialog';
import DataWithLoader from './DataWithLoader';
import SortableList from './SortableList';
import ImageWithPreview from './ImageWithPreview';
import IntegrationIcon from './IntegrationIcon';
import Chooser from './Chooser';
import DateFilter from './DateFilter';
import PhoneFilter from './PhoneFilter';
import ModifiableSelect from './ModifiableSelect';
import SortHandler from './SortHandler';
import ProjectFilter from './ProjectFilter';
import AudioPlayer from './AudioPlayer';
import SettingTheme from './SettingTheme';
import LoginFormTheme from './LoginFormTheme';
import DashboardTheme from './DashboardTheme';
import DashboardTileTheme from './DashboardTileTheme';
import HeaderDialpad from './HeaderDialpad';
import OfflineDialpad from './OfflineDialpad';
import CallHandlerTheme from './CallHandlerTheme';
import BardgeButton from './BardgeButton';
import PreviewButton from './PreviewButton';
import CallInboundTheme from './CallInboundTheme';
import DTMFTheme from './DTMFTheme';
import CallTagTheme from './CallTagTheme';
import CallInfoTheme from './CallInfoTheme';
import AddCallTheme from './AddCallTheme';
import AddNewCallTheme from './AddNewCallTheme';
import FAQTheme from './FAQTheme';
import ChatListTheme from './ChatListTheme';
import MessageListTheme from './MessageListTheme';
import OnlineScreenTheme from './OnlineScreenTheme';
import EndCallProfileTheme from './EndCallProfileTheme';
import AdminDashboardTheme from './AdminDashboardTheme';
import ManageColumns from './ManageColumns';
import EndCallAgentProfileTheme from './EndCallAgentProfileTheme';
import EndCallChangePwdTheme from './EndCallChangePwdTheme';
import CallBreakTheme from './CallBreakTheme';
import CallBreakSelectTheme from './CallBreakSelectTheme';
import CallDashboardTheme from './CallDashboardTheme';
import ContactProfileTheme from './ContactProfileTheme';
import ContactInfoActivityTheme from './ContactInfoActivityTheme';
import ContactInfoActivityTimelineTheme from './ContactInfoActivityTimelineTheme';
import CallPreviewLoading from './CallPreviewLoading';
import SelectFilterAPI from './SelectFilterAPI';
// TODO remove
const pagination = {};

export {
  Attachment,
  ActionButtons,
  NameCard,
  Button,
  Label,
  Icon,
  BreadCrumb,
  BreadCrumbItem,
  Spinner,
  Tip,
  LoadMore,
  Chip,
  Pagination,
  ProjectFilter,
  pagination,
  ReportPagination,
  ModalTrigger,
  EmptyState,
  Bulk,
  CountsByTag,
  Filter,
  FilterByParams,
  Tags,
  FilterableList,
  DropdownToggle,
  FormControl,
  Textarea,
  ControlLabel,
  FormGroup,
  Step,
  Steps,
  ConditionStep,
  TextDivider,
  Table,
  Tabs,
  TabList,
  PhoneFilter,
  TabTitle,
  ConfirmDialog,
  DataWithLoader,
  SortableList,
  ImageWithPreview,
  IntegrationIcon,
  Chooser,
  DateFilter,
  ModifiableSelect,
  SortHandler,
  SelectWithSearch,
  ChooserSelector,
  AudioPlayer,
  ImportFile,
  SettingTheme,
  LoginFormTheme,
  DashboardTheme,
  DashboardTileTheme,
  HeaderDialpad,
  OfflineDialpad,
  CallHandlerTheme,
  PreviewButton,
  BardgeButton,
  CallInboundTheme,
  DTMFTheme,
  CallTagTheme,
  CallInfoTheme,
  AddCallTheme,
  AddNewCallTheme,
  FAQTheme,
  ChatListTheme,
  MessageListTheme,
  OnlineScreenTheme,
  EndCallProfileTheme,
  AdminDashboardTheme,
  ManageColumns,
  EndCallAgentProfileTheme,
  EndCallChangePwdTheme,
  CallBreakTheme,
  CallBreakSelectTheme,
  CallDashboardTheme,
  ContactProfileTheme,
  ContactInfoActivityTheme,
  ContactInfoActivityTimelineTheme,
  CallPreviewLoading,
  SelectFilterAPI,
};



// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/index.js